'use client';

import React, { Suspense, useRef } from 'react';
import { useIntersectionObserver } from '@benzinga/hooks';
import type { InsiderCompanyTable } from './InsiderCompanyTable';

type InsiderCompanyTableProps = React.ComponentProps<typeof InsiderCompanyTable>;

const TABLE_MIN_HEIGHT = 260;

const InsiderCompanyTableLazy = React.lazy(() =>
  import('./InsiderCompanyTable').then(m => ({ default: m.InsiderCompanyTable })),
);

const TableSkeleton = ({ height }: { height: number }) => (
  <div className="w-full">
    <div
      className="flex items-center justify-center rounded-md bg-slate-100 text-sm text-slate-500"
      style={{ minHeight: height }}
    >
      Loading…
    </div>
  </div>
);

export function LazyInsiderCompanyTable(props: InsiderCompanyTableProps) {
  const ref = useRef<HTMLDivElement>(null);
  const entry = useIntersectionObserver(ref as React.RefObject<Element>, {
    freezeOnceVisible: true,
    rootMargin: '200px',
  });
  const isVisible = !!entry?.isIntersecting;

  return (
    <div ref={ref} style={{ minHeight: TABLE_MIN_HEIGHT }}>
      {isVisible ? (
        <Suspense fallback={<TableSkeleton height={TABLE_MIN_HEIGHT} />}>
          <InsiderCompanyTableLazy {...props} />
        </Suspense>
      ) : (
        <TableSkeleton height={TABLE_MIN_HEIGHT} />
      )}
    </div>
  );
}
